var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn svg-icon",class:_vm.setClasses,attrs:{"title":_vm.tooltipTitle},on:{"click":_vm.onClick}},[_c('inline-svg',{attrs:{"src":_vm.iconPath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }